import { render, staticRenderFns } from "./CardDetail.vue?vue&type=template&id=36be1e3f"
import script from "./CardDetail.vue?vue&type=script&lang=js"
export * from "./CardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports